export enum TelemonitoringRequestStep {
  TYPE = 0,
  LOCATION = 1,
  DETAILS = 2,
  SEQUENCES = 3,
  COLLABORATORS = 4,
}
